import Config from '@skin_config';

import { swarmLayers } from '@lbs/swarm-client';

import { GameTypeEnum, GameTypeViewEnum } from '@common/constants/enums/gameType';
import { getAuthData } from '@common/helpers/auth';
import { browserHistory } from '@common/helpers/browserHistory';
import ToastWrapper from '@common/helpers/toastWrapper';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { getSelectionsContextValue } from '@common/contexts/selections';
import { getBookingSelectionListSwarmRequest } from './terminalRequests/events';
import { BetslipCommunicator, BetslipEventsEnum } from '@betslip/communicator';

const getBookingDetailsV1 = (data) => {
  if (!data.data.selectionIds) {
    ToastWrapper('error', data.data);
    return;
  }

  return {
    eventIds: data.data.selectionIds,
    matchIds: data.data.MatchIds,
  };
};

const getBookingDetailsV2 = (data) => {
  if (!data.data?.bets) {
    ToastWrapper('error', data.data);
    return null;
  }

  return {
    betType: data.data.bets[0]?.BetType,
    eventIds: data.data.bets.flatMap((item) => (
      item.Selections.map((selection) => selection.SelectionId)
    )),
    matchIds: data.data.MatchIds,
    amount: data.data.bets[0]?.Amount, // replace when every single will have own stake +_+
  };
};

const checkBookId = async (data) => {
  const bookingDetails = Config.main.useBookingV2Api
    ? getBookingDetailsV2(data)
    : getBookingDetailsV1(data);

  const errorMessage = "There's not any active selection in this bet.";

  if (!bookingDetails) return 

  if (!bookingDetails?.eventIds?.length && !bookingDetails?.matchIds?.length) 
    return ToastWrapper('error', errorMessage);

  const fullselectionsTree = (
    await swarmRequest(
      getBookingSelectionListSwarmRequest(bookingDetails.eventIds, bookingDetails.matchIds),
    )
  ).data;

  const events = swarmLayers(fullselectionsTree);

  if (!events.length) {
    ToastWrapper('error', errorMessage);
    return;
  }

  const [{ boostedOddsGameIds }, setSelections] = getSelectionsContextValue();

  const selections = events.reduce(
    (acc, selection) => ({
      ...acc,
      [selection.id]: {
        game: selection.game,
        market: selection.market,
        event: selection,
        isBanker: (
          data.data?.bets
            ?.flatMap((item) => item.Selections)
            .find((sel) => sel.SelectionId === selection.id)?.IsBanker
        ),
        isBoosted: boostedOddsGameIds[selection.game.id]?.some((item) => item.Id === selection.id),
      },
    }),
    {},
  );

  setSelections((newValue) => ({
    ...newValue,
    events: selections,
    bookingAmount: bookingDetails.amount,
  }));

  if (bookingDetails.betType) {
    BetslipCommunicator.send(BetslipEventsEnum.ChangeBetType, {
      betType: bookingDetails.betType,
    });
  }
};

export const findByBookId = (id) => {
  const authData = getAuthData();
  const gameType = window.location.pathname.split('/')[1];
  const isSportPage = [
    GameTypeViewEnum[GameTypeEnum.Live],
    GameTypeViewEnum[GameTypeEnum.Prematch],
  ].includes(gameType);

  const apiUrl = Config.main.useBookingV2Api ? 'terminal_get_bet_by_bet_book_id_v2' : 'terminal_get_bet_by_bet_book_id';

  const params = { id, token: authData?.token };

  swarmRequest(params, apiUrl).then((data) => {
    if (!isSportPage) browserHistory.push('/betting/prematch');
    checkBookId(data);
  });

  window.barcodeBuffer = [];
};
